import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { initTheme } from './app/theme'
import './index.css'

// Il tema scelto si applica prima del primo render: dopo, si vedrebbe il lampo del tema sbagliato.
initTheme()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {/* Il percorso base segue quello di vite: '/' in sviluppo, '/kpo/' quando la build
        è servita sotto quel prefisso in produzione. Un valore cablato divergerebbe dai
        due ambienti al primo cambio. */}
    <BrowserRouter basename={import.meta.env.BASE_URL}>
      <App />
    </BrowserRouter>
  </StrictMode>,
)
